// Let's get things done quickly by this hacky way first
const stage = process.env.REACT_APP_ENV || 'development';

let environment: {
  STAGE: string;
  SENTRY_DSN: string;
  SENTRY_ENABLED: boolean;
  API: {
    TIMEOUT: number;
    HOST: string;
  };
  APPOINTMENT_API: {
    TIMEOUT: number;
    HOST: string;
  };
  GOOGLE_CLIENT_ID: string;
  GOOGLE_MAP_API_KEY: string;
  GOOGLE_ANALYTICS_ENABLED: boolean;
  GOOGLE_ANALYTICS_MEASUREMENT_ID?: string;
  GOOGLE_ANALYTICS_MDQ_MEASUREMENT_ID?: string;
};
switch (stage) {
  case 'production':
    environment = {
      STAGE: stage,
      SENTRY_DSN: 'https://aea76ccb7b344932bc4fc060d414fb45@o983136.ingest.sentry.io/6242029',
      API: {
        TIMEOUT: 60000,
        HOST: 'https://api.ease-healthcare.com',
      },
      APPOINTMENT_API: {
        TIMEOUT: 60000,
        HOST: 'https://api-appointment.ease-healthcare.com',
      },
      SENTRY_ENABLED: true,
      GOOGLE_CLIENT_ID: '946453602238-efa0vlbrpvmc96bk1sh2n3gskjl47c7r.apps.googleusercontent.com',
      GOOGLE_MAP_API_KEY: 'AIzaSyBOdpPUJPzutcHJ7LWjMu4T7wfLp5kKBwM',
      GOOGLE_ANALYTICS_ENABLED: true,
      GOOGLE_ANALYTICS_MEASUREMENT_ID: 'G-XHCHY3ZE4D',
      GOOGLE_ANALYTICS_MDQ_MEASUREMENT_ID: 'G-2KHPDR0D07',
    };
    break;

  case 'staging':
    environment = {
      STAGE: stage,
      SENTRY_DSN: '',
      API: {
        TIMEOUT: 60000,
        HOST: 'https://stg-api.ease-healthcare.com',
      },
      APPOINTMENT_API: {
        TIMEOUT: 60000,
        HOST: 'https://stg-api-appointment.ease-healthcare.com',
      },
      SENTRY_ENABLED: false,
      GOOGLE_CLIENT_ID: '946453602238-efa0vlbrpvmc96bk1sh2n3gskjl47c7r.apps.googleusercontent.com',
      GOOGLE_MAP_API_KEY: 'AIzaSyBOdpPUJPzutcHJ7LWjMu4T7wfLp5kKBwM',
      GOOGLE_ANALYTICS_ENABLED: false,
      // GOOGLE_ANALYTICS_MDQ_MEASUREMENT_ID: 'G-8MLVZCKHD7',
    };
    break;

  case 'test':
  case 'development':
  default:
    environment = {
      STAGE: stage,
      SENTRY_DSN: '',
      API: {
        TIMEOUT: 60000,
        HOST: 'https://stg-api.ease-healthcare.com',
      },
      APPOINTMENT_API: {
        TIMEOUT: 60000,
        HOST: 'https://stg-api-appointment.ease-healthcare.com',
      },
      SENTRY_ENABLED: false,
      GOOGLE_CLIENT_ID: '946453602238-efa0vlbrpvmc96bk1sh2n3gskjl47c7r.apps.googleusercontent.com',
      GOOGLE_MAP_API_KEY: 'AIzaSyBOdpPUJPzutcHJ7LWjMu4T7wfLp5kKBwM',
      GOOGLE_ANALYTICS_ENABLED: false,
    };
    break;
}

export default environment;
